import AlphabetPagination from './alphabet-pagination.vue'

export { AlphabetPagination }
